export default "__VITE_ASSET__op0JSKGD__"